import api from '../axios/axiosConfig';
import { ICreditCard } from '../shared/models/creditCard/creditCard';
import { IAddCardIuguResponseProps } from '../shared/models/cardIuguResponse/CardIuguResponse';

type StripeSetupIntentResponse = {
  clientSecret: string;
};

export const getUserPaymentMethods = async () => {
  try {
    const response = await api.get<ICreditCard[]>(`/UserPaymentMethods`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getUserPaymentMethodById = async (id: string) => {
  try {
    const response = await api.get<ICreditCard>(`/UserPaymentMethods/${id}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const deleteUserPaymentMethod = async (creditCardId: string) => {
  try {
    const response = await api.delete(`/UserPaymentMethods/${creditCardId}`);
    return response.status;
  } catch (error: any) {
    throw error;
  }
};

export const postUserPaymentMethod = async (userPaymentMethodsPost: any) => {
  try {
    const response = await api.post<ICreditCard[]>(
      `/UserPaymentMethods`,
      userPaymentMethodsPost
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const postIuguPaymentTokenResponse = async (
  userPaymentMethodsPost: any
) => {
  try {
    const response = await api.post<IAddCardIuguResponseProps>(
      `/payment/IuguPaymentTokenResponse`,
      userPaymentMethodsPost
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const addCreditBalance = async (
  ammount: number,
  paymentMethodId: string,
  dcId?: string
) => {
  try {
    const response = await api.post(`/wallet/Balance`, {
      Ammount: Number(ammount),
      PaymentMethod: paymentMethodId,
      dcId,
    });
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const setDefaultCreditCard = async (creditCardId: any) => {
  try {
    const response = await api.put(`/UserDefaultPaymentMethod/${creditCardId}`);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const createStripeSetupIntent = async () => {
  try {
    const response = await api.post<StripeSetupIntentResponse>(
      `/payment/stripe/payments/setupintent`
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};
